import { useMutation } from '@tanstack/react-query';
import { openAlert } from '../../../components/alert/hooks';
import { POST, POST_DESTROT_STORE } from '../../../services';

export const useDeleteStore = ({ onSuccessCallBack }) =>
  useMutation({
    mutationFn: async ({ storeId, remark }) => {
      const response = await POST(POST_DESTROT_STORE(), {
        storeId,
        remark,
      });

      if (onSuccessCallBack) onSuccessCallBack(response);

      return response;
    },
    onSuccess: () => {
      openAlert({ model: 'message', type: 'success', message: 'ลบข้อมูลร้านค้าสำเร็จ' });
    },
  });
